// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Solvency & Liability (admin) — page layout + responsive.
 * Tables → cards handled by enterprise.css (.pro-table @ <=576px).
 */
.ent.solvency-page { padding: 24px; }
.ent.solvency-page .kpi-strip { margin: 16px 0; }
.ent.solvency-page .pro-table-wrap { margin-bottom: 16px; }

.ent.solvency-page .solvency-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  padding: 0.75rem 1rem;
  border-radius: var(--ent-radius);
  margin-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.4;
}
.ent.solvency-page .solvency-banner.breach {
  background: var(--ent-red-bg, rgba(239, 68, 68, 0.08));
  border: 1px solid var(--ent-red, #ef4444);
  color: var(--ent-red, #b91c1c);
}
.ent.solvency-page .solvency-banner.ok {
  background: var(--ent-green-bg, rgba(16, 185, 129, 0.1));
  border: 1px solid var(--ent-green, #10b981);
  color: var(--ent-green, #047857);
  align-items: center;
}
.ent.solvency-page .solvency-banner strong { display: block; }

.ent.solvency-page .amount-cell__main.deficit { color: var(--ent-red, #ef4444); }

.ent.solvency-page .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: var(--ent-muted);
  gap: 0.25rem;
}
.ent.solvency-page .empty-state svg { color: var(--ent-muted); margin-bottom: 0.5rem; }
.ent.solvency-page .empty-state p { margin: 0; font-weight: 600; color: var(--ent-text); }

@media (max-width: 768px) {
  .ent.solvency-page { padding: 16px; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Solvency.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF,qBAAqB,aAAa,EAAE;AACpC,gCAAgC,cAAc,EAAE;AAChD,qCAAqC,mBAAmB,EAAE;;AAE1D;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,sDAAsD;EACtD,yCAAyC;EACzC,8BAA8B;AAChC;AACA;EACE,wDAAwD;EACxD,2CAA2C;EAC3C,gCAAgC;EAChC,mBAAmB;AACrB;AACA,6CAA6C,cAAc,EAAE;;AAE7D,gDAAgD,8BAA8B,EAAE;;AAEhF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA,sCAAsC,uBAAuB,EAAE,qBAAqB,EAAE;AACtF,oCAAoC,SAAS,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAEzF;EACE,qBAAqB,aAAa,EAAE;AACtC","sourcesContent":["/*\n * Solvency & Liability (admin) — page layout + responsive.\n * Tables → cards handled by enterprise.css (.pro-table @ <=576px).\n */\n.ent.solvency-page { padding: 24px; }\n.ent.solvency-page .kpi-strip { margin: 16px 0; }\n.ent.solvency-page .pro-table-wrap { margin-bottom: 16px; }\n\n.ent.solvency-page .solvency-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.625rem;\n  padding: 0.75rem 1rem;\n  border-radius: var(--ent-radius);\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n  line-height: 1.4;\n}\n.ent.solvency-page .solvency-banner.breach {\n  background: var(--ent-red-bg, rgba(239, 68, 68, 0.08));\n  border: 1px solid var(--ent-red, #ef4444);\n  color: var(--ent-red, #b91c1c);\n}\n.ent.solvency-page .solvency-banner.ok {\n  background: var(--ent-green-bg, rgba(16, 185, 129, 0.1));\n  border: 1px solid var(--ent-green, #10b981);\n  color: var(--ent-green, #047857);\n  align-items: center;\n}\n.ent.solvency-page .solvency-banner strong { display: block; }\n\n.ent.solvency-page .amount-cell__main.deficit { color: var(--ent-red, #ef4444); }\n\n.ent.solvency-page .empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  color: var(--ent-muted);\n  gap: 0.25rem;\n}\n.ent.solvency-page .empty-state svg { color: var(--ent-muted); margin-bottom: 0.5rem; }\n.ent.solvency-page .empty-state p { margin: 0; font-weight: 600; color: var(--ent-text); }\n\n@media (max-width: 768px) {\n  .ent.solvency-page { padding: 16px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
